var _path, _clipPath, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNiomonLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 400 401",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 .011h400v400.085H0z"
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "niomon-logo_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 .011h400v400.085H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#niomon-logo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e23c33",
    d: "M0 .011h400v400.085H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.215 282.63h72.419c91.21 0 165.151-73.941 165.151-165.151v-.001H81.215V282.63z",
    fill: "#fff",
    fillRule: "nonzero"
  }))));
}

export default __webpack_public_path__ + "static/media/niomon-logo.46cec943.svg";
export { SvgNiomonLogo as ReactComponent };